import pLimit from 'p-limit';

export const CONCURRENT_CHUNKED_QUERIES_LIMIT = 4;
export const limitConcurrentChunkedQueries = pLimit(
  CONCURRENT_CHUNKED_QUERIES_LIMIT
);

export const NAMED_GRAPHS_REQUEST_LIMIT = 1000;
